import React from "react";
import { Button, ButtonProps } from "@mui/material";

/* `component` et `to` : bouton rendu comme lien (ex. component={RouterLink}). */
type Props = ButtonProps & { component?: React.ElementType; to?: string };

/* Boutons de la charte : principal noir plein texte blanc, secondaire
   contour noir sans fond. */
export function BoutonPrincipal({ sx, ...props }: Props) {
  return (
    <Button disableElevation {...(props as any)} sx={{
      background: "var(--c-text-primary)", color: "#fff", border: "1.5px solid var(--c-text-primary)",
      borderRadius: "6px", px: 2.25, py: 0.9, fontWeight: 600, fontSize: 14, textTransform: "none",
      "&:hover": { background: "#000" },
      "&.Mui-disabled": { background: "var(--c-border)", borderColor: "var(--c-border)", color: "var(--c-text-secondary)" },
      ...(sx as any),
    }} />
  );
}

export function BoutonSecondaire({ sx, ...props }: Props) {
  return (
    <Button disableElevation {...(props as any)} sx={{
      background: "transparent", color: "var(--c-text-primary)", border: "1.5px solid var(--c-text-primary)",
      borderRadius: "6px", px: 2, py: 0.8, fontWeight: 600, fontSize: 14, textTransform: "none",
      "&:hover": { background: "var(--c-accent-subtle)" },
      "&.Mui-disabled": { borderColor: "var(--c-border)", color: "var(--c-text-secondary)" },
      ...(sx as any),
    }} />
  );
}
